import React from 'react'
import { useSelector } from 'react-redux'
import { STEP_IDS } from '../constants/fillablePDFsStepper.constants'
import { IonContent } from '@ionic/react'
import './FillablePDFs.content.css'
import { getFillablePDFsSelector } from '../selectors'
import ReviewAndSign from './ReviewAndSign'
import Details from './Details'

const FillablePDFsContent: React.FC = () => {
  const fillablePDFsState = useSelector(getFillablePDFsSelector)
  const { __currentStep } = fillablePDFsState

  const renderStepContent = () => {
    switch (__currentStep) {
      case STEP_IDS.DETAILS:
        return <Details />
      case STEP_IDS.REVIEW_AND_SIGN:
        return <ReviewAndSign />
      default:
        return null
    }
  }

  return (
    <IonContent className='ion-no-padding' color=''>
      {renderStepContent()}
    </IonContent>
  )
}

export default FillablePDFsContent
